var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGlassReplacementIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 32,
    viewBox: "0 0 55 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "glasswork_icon",
    transform: "translate(-0.001 -11.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1459",
    "data-name": "Trazado 1459",
    d: "M54.937,35.7,50.042,14.115a2.683,2.683,0,0,0-1.229-1.7,2.77,2.77,0,0,0-2.069-.342c-2.3.511-7.682,1.709-19.243,1.709s-16.944-1.2-19.251-1.71a2.781,2.781,0,0,0-2.065.343,2.683,2.683,0,0,0-1.226,1.7L.065,35.7a2.673,2.673,0,0,0,.842,2.583C3.308,40.418,9.957,44,27.5,44s24.192-3.581,26.593-5.716a2.673,2.673,0,0,0,.842-2.583Zm-2.082,1.278c-1.775,1.573-7.8,5.244-25.354,5.244S3.922,38.55,2.147,36.977a.924.924,0,0,1-.292-.889L6.75,14.5a.94.94,0,0,1,1.1-.7c2.358.525,7.882,1.755,19.651,1.755S44.794,14.326,47.158,13.8a.949.949,0,0,1,1.095.7L53.146,36.08a.925.925,0,0,1-.292.9Z",
    transform: "translate(0)",
    fill: "#293338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1460",
    "data-name": "Trazado 1460",
    d: "M42.4,27.868H38.866l-6.335-.792V22.7l1.7-3.4a.9.9,0,1,0-1.606-.8L30.9,21.954l-2.855,2.851-2.781-2.781-.836-3.346a.9.9,0,0,0-1.74.434l.834,3.335L21.927,27.23l-4.86,2.432H11.9a.9.9,0,1,0,0,1.794h5.2l5.676,2.433.758,3.789-.822,2.465a.9.9,0,1,0,1.7.567l.831-2.489,3.927-3.928,6.594,2.473,3.537,1.777a.9.9,0,0,0,.8-1.606l-3.354-1.677L34.69,31.83l4.331-2.167H42.4a.9.9,0,0,0,0-1.794Zm-9.372,2.781a.9.9,0,0,0-.368,1.265L34.027,34.2l-4.769-1.79a.9.9,0,0,0-.95.206l-3.3,3.3-.569-2.841a.9.9,0,0,0-.526-.649l-4.5-1.929,3.652-1.818a.9.9,0,0,0,.449-.519l1.337-4,2.561,2.561a.9.9,0,0,0,1.268,0l2.058-2.062v3.217a.9.9,0,0,0,.786.89l4.237.53Z",
    transform: "translate(-0.593 -0.914)",
    fill: "#293338"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGlassReplacementIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/glass_replacement_icon.ec8ef2d7.svg";
export { ForwardRef as ReactComponent };